module.exports = __webpack_public_path__ + "img/service-pic.bf0914f9.png";